export const legalDocumentUrls = {
  engagements: 'https://www.francefrais.fr/nos-valeurs-demarche-rse',
  cgu: 'https://storage.googleapis.com/ffconnect-medias/cgu.pdf',
  confidentialite:
    'https://storage.googleapis.com/ffconnect-medias/confidentialite.pdf',
  cookies: 'https://storage.googleapis.com/ffconnect-medias/cookies.pdf',
} as const;
